module.exports = __webpack_public_path__ + "media/img/doguinhoLima-94468aff.png";